<template>
  <default-step-container v-on="containerListeners" :required="required">
    <template #question>{{ question }}</template>
    <template #help>{{ help }}</template>
    <template #default>
      <div>
        <component
            v-for="(input, name) in inputs"
            :key="name"
            :is="getComponent(input.type)"
            v-bind="input"
            v-model="form[name]"
            :invalid="form.errors[name]"
            class="wizard-step-input"
        ></component>
        <p>*verpflichtende Angaben</p>
      </div>
    </template>
  </default-step-container>
</template>
<script>
import DefaultStepContainer from './DefaultStepContainer'
import DateInput from './DateInput'
import EmailInput from './EmailInput'
import FileInput from './FileInput'
import OptionsInput from './OptionsInput'
import RangeInput from './RangeInput'
import SelectInput from './SelectInput'
import TelInput from './TelInput'
import TextareaInput from './TextareaInput'
import TextInput from './TextInput'
import v8n from 'v8n'
import each from 'lodash/each'

export default {
  components: {
    DefaultStepContainer,
    DateInput,
    EmailInput,
    FileInput,
    OptionsInput,
    RangeInput,
    SelectInput,
    TelInput,
    TextareaInput,
    TextInput
  },

  props: {
    question: {
      type: String,
      default: ''
    },
    help: {
      type: String,
      default: '',
    },
    inputs: {
      type: Object,
      default () {
        return []
      }
    },
    form: {
      type: Object,
      required: true
    },
    required: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    getComponent (type) {
      return type + '-input'
    },

    onNext () {
      let hasErrors = false
      each(this.inputs, (input, name) => {
        let rule = (input.rule || (v => v()))(v8n, this.form)
        let errors = rule.testAll(this.form[name])

        if (errors.length === 0) {
          this.$delete(this.form.errors, name)
          return
        }

        hasErrors = true

        this.$set(this.form.errors, name, input.errorMessage || 'Invalid input.')
      })

      if (!hasErrors) {
        this.$emit('next')
      }
    }
  },

  computed: {
    containerListeners () {
      return {
        back: this.$listeners.back || (() => {}),
        next: this.onNext,
      }
    }
  }
}
</script>

<style lang="scss">
.wizard-step {
  max-width: 860px;
  margin: auto;
  .wizard-step-input + .wizard-step-input {
    margin-top: 1rem;
  }
}
</style>
